module.exports = __webpack_public_path__ + "static/media/online-reservation-poster.495980fa.jpg";